import { api } from './api'

export interface AIConsentStatus {
  projectId: string
  aiProcessingGranted: boolean
  aiTrainingOptIn: boolean
  consents: Array<{ id: string; consentType: string; granted: boolean; revokedAt?: string | null }>
}

const localKey = (projectId: string) => `infergraph.aiConsent.${projectId}`

const aiConsentService = {
  async get(projectId: string): Promise<AIConsentStatus> {
    try {
      const response = await api.get<AIConsentStatus>(`/api/projects/${projectId}/consents`)
      return response.data
    } catch {
      return {
        projectId,
        aiProcessingGranted: localStorage.getItem(localKey(projectId)) === 'granted',
        aiTrainingOptIn: false,
        consents: [],
      }
    }
  },

  async grant(projectId: string): Promise<void> {
    localStorage.setItem(localKey(projectId), 'granted')
    await api.post(`/api/projects/${projectId}/consents`, {
      consentType: 'ai_processing',
      granted: true,
      source: 'ai_consent_gate',
      noticeVersion: '2026-05-16',
    }).catch(() => undefined)
  },

  async requestDeletion(projectId: string, scope: string[]): Promise<{ id: string; status: string }> {
    const response = await api.post(`/api/projects/${projectId}/dsr/deletion`, { scope })
    return response.data
  },
}

export default aiConsentService
